<template>
  <div class="form-group col-12">
    <label class="col-form-label"> </label>
    <!-- {{broadcastParam}} -->
    <div class="message-bar">
      <div class="message-inner">
        <div class="message-area">
          <div class="input-group">
            <textarea
              :style="'height:300px'"
              ref="messagebox"
              class="form-control"
              v-model="text"
              :placeholder="'Type message...'"
              @blur="saveCursorPosition"
              @click="saveCursorPosition"
              @keyup="saveCursorPosition"
              @select="saveCursorPosition"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 px-0">
      <div class="card border-0">
        <div class="card-body">
          <a-button
            class="broadcast-emoji-trigger"
            title="Emoji"
            @click="emojiToggle()"
          >
            <img style="width: 15px" src="@/assets/emoji.png" alt="Emoji" />
          </a-button>

          <a-popover
            :visible="variableMenuVisible"
            trigger="click"
            :placement="variablePlacement"
            :auto-adjust-overflow="true"
            :get-popup-container="getVariablePopupContainer"
            overlay-class-name="broadcast-variable-popover"
            @visibleChange="onVariableMenuVisible"
          >
            <span class="broadcast-variable-trigger-wrap">
              <button
                ref="variableTrigger"
                type="button"
                class="btn btn-sm btn-outline-secondary btn-rounded broadcast-variable-trigger"
                title="Sisipkan variabel"
                aria-label="Sisipkan variabel"
              >
                <i class="fa fa-plus"></i>
                Variabel
              </button>
              <span class="broadcast-variable-new-badge">NEW</span>
            </span>

            <div slot="content" class="broadcast-variable-panel">
              <div class="broadcast-variable-search">
                <a-input
                  ref="variableSearchInput"
                  v-model="variableSearch"
                  placeholder="Cari nama atau deskripsi variabel..."
                  size="small"
                  allowClear
                />
              </div>

              <div class="broadcast-variable-list">
                <div
                  v-if="filteredTemplateMessages.length"
                  class="broadcast-variable-group"
                >
                  <div class="broadcast-variable-group-header">
                    <span class="broadcast-variable-group-title">
                      Variable Statis
                    </span>
                    <span class="broadcast-variable-group-count">
                      {{
                        hasVariableSearch
                          ? filteredTemplateMessages.length +
                            " / " +
                            templateMessage.length
                          : templateMessage.length
                      }}
                    </span>
                  </div>

                  <a-menu
                    :selectable="false"
                    class="broadcast-variable-menu"
                  >
                    <a-menu-item
                      v-for="temp in filteredTemplateMessages"
                      :key="temp"
                      @click="addTemplateToMesage(temp)"
                    >
                      <span class="broadcast-variable-item-name">
                        {{ temp }}
                      </span>
                    </a-menu-item>
                  </a-menu>
                </div>

                <div
                  v-if="
                    filteredVariableRows.length ||
                    !hasVariableSearch ||
                    variableLoading ||
                    variableError
                  "
                  class="broadcast-variable-group"
                >
                  <div class="broadcast-variable-group-header">
                    <span class="broadcast-variable-group-title">
                      {{ dynamicGroupLabel }}
                    </span>
                    <div class="broadcast-variable-group-actions">
                      <span class="broadcast-variable-group-count">
                        {{
                          hasVariableSearch
                            ? filteredVariableRows.length +
                              " / " +
                              variableRows.length
                            : variableRows.length
                        }}
                      </span>
                      <button
                        type="button"
                        class="broadcast-variable-refresh"
                        title="Refresh variable"
                        aria-label="Refresh variable"
                        :disabled="variableLoading"
                        @click.stop="loadVariables(true)"
                      >
                        <i
                          class="fa fa-refresh"
                          :class="{ 'fa-spin': variableLoading }"
                        ></i>
                      </button>
                    </div>
                  </div>

                  <a-menu
                    :selectable="false"
                    class="broadcast-variable-menu"
                  >
                    <a-menu-item
                      v-if="variableLoading && !variableLoaded"
                      disabled
                    >
                      <i class="fa fa-spinner fa-spin"></i>
                      Memuat variable...
                    </a-menu-item>

                    <template v-else-if="variableError">
                      <a-menu-item disabled class="text-danger">
                        Gagal memuat variable.
                      </a-menu-item>
                      <a-menu-item @click="loadVariables(true)">
                        <i class="fa fa-refresh"></i> Coba lagi
                      </a-menu-item>
                    </template>

                    <template v-else-if="filteredVariableRows.length">
                      <a-menu-item
                        v-for="row in filteredVariableRows"
                        :key="row.id"
                        @click="insertVariableAtCursor(row.variable_name)"
                      >
                        <div class="broadcast-variable-item">
                          <span
                            class="broadcast-variable-item-name"
                            :title="row.variable_name"
                          >
                            {{ "${" + row.variable_name + "}" }}
                          </span>
                          <span
                            v-if="row.description"
                            class="broadcast-variable-item-desc"
                            :title="row.description"
                          >
                            {{ row.description }}
                          </span>
                        </div>
                      </a-menu-item>
                    </template>

                    <template v-else-if="hasVariableSearch">
                      <a-menu-item disabled>
                        Variable tidak ditemukan
                      </a-menu-item>
                    </template>

                    <template v-else>
                      <a-menu-item disabled>
                        Belum ada variable yang dibuat.
                      </a-menu-item>
                    </template>
                  </a-menu>
                </div>

                <div
                  v-if="
                    hasVariableSearch &&
                    !hasFilteredVariables &&
                    !variableLoading &&
                    !variableError
                  "
                  class="broadcast-variable-empty"
                >
                  Variabel tidak ditemukan.
                </div>
              </div>

              <div class="broadcast-variable-footer">
                <a
                  :href="variableMasterUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Kelola Variable
                </a>
              </div>
            </div>
          </a-popover>
          <a-button-group>
            <a-button @click="applyStyle('*')" style="font-weight: bold"
              >B</a-button
            >
            <a-button @click="applyStyle('_')" style="font-style: italic"
              >I</a-button
            >
            <a-button
              @click="applyStyle('~')"
              style="text-decoration: line-through"
              >s</a-button
            >
            <a-button @click="applyStyle('```')" style="font-family: monospace"
              >MONO</a-button
            >
              <!-- <a-button
              :loading="loading"
              v-if="text.length >= 15"
              @click="checkRecomendation({text:text,language_style:''})"
              style="font-family: monospace"
            >
              <i class="fa fa-magic mr-2"></i> &nbsp;Use AI</a-button
            >  -->
          </a-button-group>
          <AIComponent v-model="text" />
          <Emoji
            :open="emojiAttr.open"
            :width="emojiAttr.width"
            :height="emojiAttr.height"
            style="z-index: 9999"
            searchLabel="Search emoji here"
            @click="selectedEmoji"
          />
        </div>
      </div>
    </div>
    
    <!-- <OffCanvas
      ref="offcanvas"
      v-model="showPanel"
      position="right"
      size="400px"
      :closeOnOverlay="true"
    >
      <template v-slot:header>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
          "
        >
          <h3 style="margin: 0">Rekomendasi Text By AI</h3>
          <button
            class="btn"
            @click="$refs.offcanvas.close()"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <div> 
        <div v-if="recomendation.length > 0" class="p-3">
          <div
            v-for="({text:item, language_style}, index) in recomendation"
            :key="index"
            class="card mb-3 shadow-sm"
          >
            <div class="card-body">
               <p class="mb-3" v-html="$util.htmlEntity(item)"> </p>
              <div class="d-flex justify-content-between border-top pt-2 align-items-center">
                <small class="text-muted " style="text-transform: capitalize;">
                  {{ language_style.replace('_', ' ') }}
                </small>
               <button class="btn btn-sm m-1 btn-primary btn-pill" @click="text = item; showPanel = false;">
                Gunakan
               </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center p-5">
          <p class="text-muted">Belum ada rekomendasi yang tersedia.</p>
        </div> 
         <div v-if="loading" class="card">
           <div  class="card-body">
            <Skeleton :height="'20px'" :count="2" />
            <div class="mt-3 text-right">
              <Skeleton :height="'20px'" :width="'25%'" :count="1" />
            </div>
         </div> 
        </div>
        <div v-if="language_style" class="p-3 border-top">
          <h5 class="mb-3"> atau coba lagi dengan gaya bahasa lainnya:</h5>
          <button :disabled="loading" v-show="!checkExist(item.key)" class="btn btn-sm m-1 btn-outline-secondary btn-pill" v-for="(item, index) in language_style" :key="index" @click="generateMore(item)">
             {{ item.label }}
           </button>
        </div>
      </div>
    </OffCanvas> -->
  </div>
</template>

<script>
import { VueChatEmoji, emojis } from "vue-chat-emoji";
import OffCanvas from "@/components/TextReply/offCanvas.vue";
import { Skeleton } from "vue-loading-skeleton";
export default {
  components: {
    Emoji: VueChatEmoji,
    OffCanvas: OffCanvas,
    Skeleton: Skeleton,
    AIComponent: () => import("@/components/AIComponent"),
  },
  props: {
    value: {
      type: String,
      default: () => "",
    },
    dynamicGroupLabel: {
      type: String,
      default: "Variable Saya",
    },
  },
  data() {
    return {
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}",
      ],
      variableRows: [],
      variableSearch: "",
      variableMenuVisible: false,
      variablePlacement: "bottomLeft",
      variableLoading: false,
      variableLoaded: false,
      variableError: false,
      lastCursorPos: null,
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px",
      }, 
    };
  },
  computed: {
    language_style() {
      return this.$store.state.aiKey.language_style;
    },
    text: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    variableKeyword() {
      return (this.variableSearch || "").trim().toLowerCase();
    },
    hasVariableSearch() {
      return this.variableKeyword !== "";
    },
    filteredTemplateMessages() {
      const keyword = this.variableKeyword;
      const rows = this.templateMessage || [];

      if (!keyword) {
        return rows;
      }

      return rows.filter((template) => {
        return String(template || "").toLowerCase().indexOf(keyword) !== -1;
      });
    },
    filteredVariableRows() {
      const keyword = this.variableKeyword;
      const rows = this.variableRows || [];

      if (!keyword) {
        return rows;
      }

      return rows.filter((row) => {
        const name = String(row.variable_name || "").toLowerCase();
        const description = String(row.description || "").toLowerCase();
        return (
          name.indexOf(keyword) !== -1 ||
          description.indexOf(keyword) !== -1
        );
      });
    },
    hasFilteredVariables() {
      return (
        this.filteredTemplateMessages.length > 0 ||
        this.filteredVariableRows.length > 0
      );
    },
    variableMasterUrl() {
      return this.$router.resolve({ name: "variable" }).href;
    },
  }, 
  mounted() {
    this.$store.dispatch("aiKey/getLanguageStyle");
    window.addEventListener("resize", this.onVariableViewportResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onVariableViewportResize);
  },
  methods: {
    onVariableMenuVisible(visible) {
      this.variableMenuVisible = visible;

      if (visible) {
        this.saveCursorPosition();
        this.updateVariablePlacement();
        this.loadVariables(true);
        this.$nextTick(() => {
          const searchInput = this.$refs.variableSearchInput;
          if (searchInput && typeof searchInput.focus === "function") {
            searchInput.focus();
          }
        });
      } else {
        this.variableSearch = "";
      }
    },
    updateVariablePlacement() {
      const trigger = this.$refs.variableTrigger;
      if (!trigger) {
        return;
      }

      const rect = trigger.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight || 0;
      const popoverHeight = Math.min(360, viewportHeight * 0.6);
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;

      this.variablePlacement =
        spaceBelow < popoverHeight + 16 && spaceAbove > spaceBelow
          ? "topLeft"
          : "bottomLeft";
    },
    onVariableViewportResize() {
      if (this.variableMenuVisible) {
        this.updateVariablePlacement();
      }
    },
    getVariablePopupContainer() {
      return document.body;
    },
    addTemplateToMesage(template) {
      this.insertTextAtCursor(template);
    },
    async loadVariables(force) {
      if (this.variableLoading) {
        return;
      }

      if (this.variableLoaded && !force) {
        return;
      }

      this.variableLoading = true;
      this.variableError = false;

      try {
        const response = await this.$store.dispatch(
          "variable/getVariableList",
          {
            page: 1,
            per_page: 100,
            search: "",
          }
        );
        const { data } = response;

        this.variableRows = (data && data.data) || [];
        this.variableLoaded = true;
      } catch (error) {
        this.variableError = true;
      } finally {
        this.variableLoading = false;
      }
    },
    saveCursorPosition() {
      const messagebox = this.$refs.messagebox;

      if (!messagebox) {
        return;
      }

      if (
        typeof messagebox.selectionStart === "number" &&
        typeof messagebox.selectionEnd === "number"
      ) {
        this.lastCursorPos = {
          start: messagebox.selectionStart,
          end: messagebox.selectionEnd,
        };
      }
    },
    insertVariableAtCursor(variableName) {
      this.insertTextAtCursor("${" + variableName + "}");
    },
    insertTextAtCursor(textToInsert) {
      const insertedText = String(textToInsert || "");
      if (!insertedText) {
        return;
      }

      const currentText = this.text || "";
      const messagebox = this.$refs.messagebox;
      let start;
      let end;

      if (this.lastCursorPos && typeof this.lastCursorPos.start === "number") {
        start = this.lastCursorPos.start;
        end =
          typeof this.lastCursorPos.end === "number"
            ? this.lastCursorPos.end
            : start;
      } else if (messagebox && typeof messagebox.selectionStart === "number") {
        start = messagebox.selectionStart;
        end =
          typeof messagebox.selectionEnd === "number"
            ? messagebox.selectionEnd
            : start;
      } else {
        // Fallback: tambahkan di akhir bila posisi kursor tidak tersedia.
        this.text = currentText + insertedText;
        this.variableMenuVisible = false;
        return;
      }

      start = Math.min(Math.max(start, 0), currentText.length);
      end = Math.min(Math.max(end, start), currentText.length);

      this.text =
        currentText.substring(0, start) +
        insertedText +
        currentText.substring(end);

      this.variableMenuVisible = false;
      const cursorAfter = start + insertedText.length;
      this.lastCursorPos = { start: cursorAfter, end: cursorAfter };

      this.$nextTick(() => {
        if (this.$refs.messagebox) {
          this.$refs.messagebox.focus();
          this.$refs.messagebox.setSelectionRange(cursorAfter, cursorAfter);
        }
      });
    },
    applyStyle(symbol) {
      const textarea = this.$refs.messagebox;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      const text = this.text;
      let symbolLength = symbol.length
      this.text =
        text.slice(0, start) +
        symbol +
        text.slice(start, end) +
        symbol +
        text.slice(end);

      // this.showMenu = false;

      // this.$nextTick(() => {
      //   textarea.focus();
      //   const cursorPos = start + symbol.length;
      //   textarea.setSelectionRange(cursorPos, cursorPos);
      //   this.$refs.messagebox.focus();
      // });
      this.$nextTick(() => {
        textarea.focus();
        const selectStart = start 
        const selectEnd = end + symbolLength * 2
        textarea.setSelectionRange(selectStart, selectEnd);
        this.$refs.messagebox.focus();
        });
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      const textarea = this.$refs.messagebox; // pastikan textarea punya ref="messagebox"
      if (!textarea) return;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      this.text =
        this.text.substring(0, start) + args.emoji + this.text.substring(end);
      this.$nextTick(() => {
        textarea.focus();
        const cursorPos = start + args.emoji.length;
        textarea.setSelectionRange(cursorPos, cursorPos);
      });
      this.emojiToggle(false);
      // console.log(args); /* return {...}*/
    },
  },
};
</script>

<style>
.broadcast-emoji-trigger {
  margin-right: 6px;
  vertical-align: middle;
}

.broadcast-variable-trigger-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-right: 8px;
  overflow: visible;
}

.broadcast-variable-trigger {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  font-size: 13px;
  line-height: 1.4;
  white-space: nowrap;
}

.broadcast-variable-trigger .fa {
  margin-right: 4px;
}

.broadcast-variable-new-badge {
  position: absolute;
  top: -7px;
  right: -9px;
  z-index: 10;
  background-color: #fe9b44;
  color: #ffffff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.2;
  padding: 1px 5px;
  border-radius: 999px;
  pointer-events: none;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.broadcast-variable-popover {
  z-index: 2000;
  max-width: calc(100vw - 24px);
}

.broadcast-variable-popover .ant-popover-inner-content {
  padding: 0;
}

.broadcast-variable-popover .ant-popover-inner {
  border-radius: 8px;
  overflow: hidden;
}

.broadcast-variable-panel {
  display: flex;
  flex-direction: column;
  width: min(360px, calc(100vw - 32px));
  max-height: min(360px, 60vh);
  background: #fff;
  overflow: hidden;
}

.broadcast-variable-search {
  flex: 0 0 auto;
  padding: 10px 12px 8px;
  border-bottom: 1px solid #f0f0f0;
}

.broadcast-variable-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.broadcast-variable-group-header {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #fff;
}

.broadcast-variable-group-title {
  font-weight: 600;
  font-size: 12px;
  color: #8c8c8c;
}

.broadcast-variable-group-actions {
  display: flex;
  align-items: center;
}

.broadcast-variable-group-count {
  font-size: 11px;
  color: #8c8c8c;
  margin-left: 4px;
}

.broadcast-variable-refresh {
  background: transparent;
  border: 0;
  padding: 0 4px;
  color: #1890ff;
  line-height: 1;
  cursor: pointer;
}

.broadcast-variable-refresh:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.broadcast-variable-menu {
  border: 0;
  box-shadow: none;
  background: transparent;
  padding: 0;
}

.broadcast-variable-menu .ant-menu-item {
  height: auto;
  line-height: 1.4;
  padding: 7px 12px;
  margin: 0;
  white-space: normal;
}

.broadcast-variable-menu .ant-menu-item:hover {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.65);
}

.broadcast-variable-menu .ant-menu-item-disabled,
.broadcast-variable-menu .ant-menu-item-disabled:hover {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.broadcast-variable-item {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.broadcast-variable-item-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.broadcast-variable-item-desc {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: #8c8c8c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.broadcast-variable-empty {
  padding: 12px;
  font-size: 13px;
  color: #8c8c8c;
  text-align: center;
}

.broadcast-variable-footer {
  flex: 0 0 auto;
  padding: 8px 12px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
  background: #fff;
}

.broadcast-variable-footer a {
  font-size: 13px;
}
</style>
 


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/chatComponent.vue